import validator from 'validator';

export default ({ field, fieldName, fieldMessage }) => {
  return !validator.isEmpty(field) && validator.isNumeric(field)
    ? []
    : [{ field: fieldName, message: fieldMessage }];
};
